// extracted by mini-css-extract-plugin
export default {"customers-page":"customers_customers-page__Yi+Vw","header":"customers_header__UD5dM"};